(function($, undefined) {
	
	'use strict';
	var playerTools;
	var popup;
	var formValidator;
	var session;
	var utils;

	var changeOrder = function() {
		var t = $(this);

		$('.order-input').val(t.attr('data-val'));

		if (t.hasClass('no-border')) {
			applyFilters();
		}

		$('.change-order-btn:not(.no-border)').addClass('no-border');
		t.removeClass('no-border');
	};

	var changeSortOrder = function() {
		var t = $(this);
        var currSort = t.attr('data-val');
        var newSort = currSort === 'desc' ? 'asc' : 'desc';

        t.attr('data-val', newSort);
		$('.sort-order-input').val(newSort);
        applyFilters();
	};
    
	var changeStudioFilter = function() {
		var t = $(this);


		if (t.hasClass('no-border')) {
            t.removeClass('no-border');
//            $('.change-sourceConnect-filter').removeClass('no-border');
            $('.studio-input').val(t.attr('data-val'));
//            $('.sourceConnect-input').val(t.attr('data-val'));
		} else {            
            t.addClass('no-border');
//            $('.change-sourceConnect-filter').addClass('no-border');
            $('.studio-input').val("");
//            $('.sourceConnect-input').val("");
        }
        applyFilters();
	};
    
	var changeSourceConnectFilter = function() {
		var t = $(this);


		if (t.hasClass('no-border')) {
            $('.sourceConnect-input').val(t.attr('data-val'));
            t.removeClass('no-border');
//			applyFilters();
		} else {
//            if ($('.change-studio-filter').hasClass("no-border")) {
                $('.sourceConnect-input').val("");
                t.addClass('no-border');  
//                applyFilters();             
//            }
        }
        applyFilters();   

	};

	var changeMedia = function() {
		var t = $(this);

		$('.media-input').val(t.attr('data-val'));

		if (t.hasClass('no-border')) {
			var data = '';
			var inputs = $('.filters-ctn-js').find('input:not(.ignore-media), select:not(.ignore-media)');

			inputs.each(function(i) {
				if ($(this).val().length !== 0) {
					data.length === 0 ? data += '?' : data += '&';
					data += $(this).attr('name') + '=' + $(this).val().trim();
				}
			});
			
			filterAjax(data, null, 'filter-media-js');
		}

		$('.change-media-btn:not(.no-border)').addClass('no-border');
		t.removeClass('no-border');
	};
	
	var toggleSubcatsCtn = function() {
		var t = $(this);
		var catId = t.attr('data-id');
		var extraSel;
		var delay;

		t.hasClass('main-lang') ? extraSel = '.sub-lang' : extraSel = ':not(.sub-lang)';
		var openedCat = $('.voice-filter-subcats-outer-ctn' + extraSel + '.open').attr('data-id');

		if (!t.hasClass('main-lang')) {
			if ($('.voice-filter-subcats-outer-ctn' + extraSel + '.open').length > 0 && openedCat !== catId) {
				$('.voice-filter-subcats-outer-ctn' + extraSel + '.open').slideUp().removeClass('open');
				$('.voice-filter-cat-btn:not(.main-lang)[data-id=' + openedCat + ']').removeClass('voice-filter-selected');
				delay = 400;
			}
		}

		setTimeout(function() {
			$('.voice-filter-subcats-outer-ctn' + extraSel + '[data-id=' + catId + ']').slideToggle().toggleClass('open');
			if (!t.hasClass('main-lang')) {
				$('.voice-filter-cat-btn[data-id=' + catId + ']').toggleClass('voice-filter-selected');
			}
		}, delay);
	};

	var closeSubcatsCtn = function() {
		var ctn = $(this).closest('.voice-filter-subcats-outer-ctn');
		var id = ctn.attr('data-id');

		ctn.slideUp().removeClass('open');
		$('.voice-filter-cat-btn[data-id=' + id + '].voice-filter-selected').removeClass('voice-filter-selected');
	};

	var toggleSubcatSearch = function() {
		var t = $(this);
		var id = t.attr('id');
		var ctn = t.closest('.voice-filter-subcats-outer-ctn:not(.sub-lang)');
		var input = ctn.find('.field-input');
		var val = input.val().length ? input.val().split(',') : [];
		var qty = $('.voice-filter-cat-btn[data-id=' + ctn.attr('data-id') + ']').find('.qty');

		$('.voice-filter-subcat-btn[id=' + id + ']').toggleClass('voice-filter-selected');

		if (t.hasClass('voice-filter-selected')) {
			val.push(t.attr('id'));
		} else {
			val.splice(val.indexOf(t.attr('id')), 1);
		}

		input.val(val);

        var iwdPopup = $('.popup[data-id="international-womens-day-popup"]');
        //Trigger Popup for the international women's day
        if (input.val() == "m" && !t.hasClass('trigger-from-popup') && iwdPopup.length) {
            iwdPopup.addClass('open');
            if (!iwdPopup.hasClass('no-overlay')) {
                $('body').addClass('popup-show');
            }

            if (iwdPopup.find('.init-addthis').length > 0) {
                iwdPopup.find('.init-addthis').addClass(iwdPopup.find('.init-addthis').attr('data-class'));
                addthis.layers.refresh();
            }

            val = [];
            input.val(val);
            $("#m").removeClass('voice-filter-selected');
            $("#f").removeClass('voice-filter-selected');
            t.removeClass('trigger-from-popup');
        } else {
            if (t.hasClass('sub-lang') || t.hasClass('main-lang')) {
                $('.sub-langs-ctn.hide-responsive .voice-filter-subcats-outer-ctn.sub-lang').each(function() {
                    if ($(this).find('.voice-filter-subcat-btn.voice-filter-selected').length && val.indexOf($(this).attr('data-id')) !== -1) {
                        val.splice(val.indexOf($(this).attr('data-id')), 1);
                    }
                });
            }

            qty.html(val.length);

            if (t.hasClass('sub-lang')) {
                if (t.hasClass('sub-lang')) {
                    var subLangQtyCtn = ctn.find('.voice-filter-subcat-btn[data-id=' + t.closest('.voice-filter-subcats-outer-ctn.sub-lang').attr('data-id') + ']').find('.sub-lang-qty');
                    var subLangQty = t.closest('.voice-filter-subcats-outer-ctn.sub-lang').find('.voice-filter-subcat-btn.voice-filter-selected').length;
                    subLangQtyCtn.html(subLangQty);
                }
            }

            applyFilters();
        }
	};

	var applyFilters = function() {
		var allFilters = $('.filters-ctn-js');
		var data = {};
		var inputs = allFilters.find('input, select');
        
		if (utils.getQuery('page')) {
            data.page = utils.getQuery('page');
		}

		inputs.each(function(i) {
            var $_ = $(this);
			if ($_.val().length !== 0 || (($_.attr('name') === 'month' || $_.attr('name') === 'year') && ($('select[name=month]').val().length !== 0 || $('select[name=year]').val().length !== 0))) {
                data[$_.attr('name')] = $_.val().trim();
			}
		});
        
        if($('.auditions-invitation-studio-chk').length !== 0){
            data.studio = $('.auditions-invitation-studio-chk').is(":checked");
        }
        if($('.auditions-invitation-sourceConnect-chk').length !== 0){
            data.sourceConnect = $('.auditions-invitation-sourceConnect-chk').is(":checked");
        }
        
        var str;
        for (var k in data) {
            if (!str)
                str = "?";
            else
                str += "&";
            str += k + "=" + data[k];
        }
		filterAjax(str);
	};

	var filterAjax = function(data, callback, elementsCtnClass) {
		var url = $('.filters-ctn-js').attr('data-url');
        if(url !== undefined){
            var ctn = $('.filter-outer-ctn-js');

            if (!elementsCtnClass) {
                ctn.addClass('is-processing');
                $('.voice-filter-subcats-outer-ctn').addClass('is-processing');
            } else {
                $('.' + elementsCtnClass).addClass('is-processing');
            }
            var studio = '';
            var source = '';
            if ($('.auditions-invitation-studio-chk').length !== 0) {
                studio = $('.auditions-invitation-studio-chk').is(":checked");
            }
            if ($('.auditions-invitation-sourceConnect-chk').length !== 0) {
                source = $('.auditions-invitation-sourceConnect-chk').is(":checked");
            }
            
            var encodedData = '';
            if (typeof data === 'string') {
                url += data;
                encodedData = encodeURIComponent(data);
            }
            session.save('searchFilters', encodedData, function () {
                $.ajax({
                    url: url,
                    cache: false,
                    method: 'GET',
                    success: function (response) {
                        if (!elementsCtnClass) {
                            var elements = $('.filtered-elements-ctn-js', $.parseHTML(response));

                            if (studio !== '' && source !== '') {
                                $('.auditions-invitation-studio-chk', elements).prop('checked', studio);
                                $('.auditions-invitation-sourceConnect-chk', elements).prop('checked', source);
                            }

                            $('.filtered-elements-ctn-js').html(elements.children());

                            if ($('.js-copy-ctn').length > 0) {
                                var demosPopupsAndPager = $('.js-copy-ctn', $.parseHTML(response));
                                $('.js-copy-ctn').html(demosPopupsAndPager.children());
                            }
                            ctn.removeClass('is-processing');
                            $('.voice-filter-subcats-outer-ctn').removeClass('is-processing');
                        } else {
                            var elements = $('.' + elementsCtnClass, $.parseHTML(response));
                            $('.' + elementsCtnClass).html(elements.children());
                            $('.' + elementsCtnClass).removeClass('is-processing');
                        }

                        if (callback) {
                            callback();
                        }
                    },
                    error: function (response) {
                        console.log('error : ' + response.statusText);
                    }
                });
            });
        }
	};

	var clearFilters = function() {
        filterAjax('', function () {
            $('.find-a-voice-filter-q-input').val('');
            $('.change-order-btn').addClass('no-border');
            $('.change-studio-filter').addClass('no-border');
            $('.change-sourceConnect-filter').addClass('no-border');
            $('.change-order-btn[data-val=random]').removeClass('no-border');
            $('.qty').html(0);
            $('.sub-lang-qty').html(0);
            $('.voice-filter-cat-btn').removeClass('voice-filter-selected');
            $('.voice-filter-subcat-btn').removeClass('voice-filter-selected');
            $('.voice-filter-subcats-outer-ctn').slideUp();
            $('.filters-ctn-js').find('input[type=hidden]').val('');
            window.history.pushState({}, document.title, window.location.pathname);
        });
	};
	
	var enterApplyFilters = function(e) {
		if ((e.which || e.keyCode) === 13) {
			applyFilters();
		}
	};

	var toggleDemosOnly = function() {
		var t = $(this);
		var input = $('.demos-only');
		t.toggleClass('no-border');

		!t.hasClass('no-border') ? input.val('true') : input.val('');

		applyFilters();
	};

	var changeDefaultRegion = function() {
		var t = $(this);
		var popup = t.closest('.popup');
		var select = popup.find('select[name="region"]');
		var val = !t.hasClass('close-region-popup-btn') ? select.val() : '';

		t.addClass('disabled');
		popup.addClass('is-processing');

		session.save('region', val, function() {
			t.removeClass('disabled');
			if (!t.hasClass('close-region-popup-btn')) {
				formValidator.showSuccessPopup('changed-region-success');
			}
			window.location.reload();
		});
	};
	
	var hijackAccount = function(){
		var btn = $(this);
		btn.prev(".hijack-form").submit();
	};

    var activeWomenFilter = function(){
        $( "#f" ).addClass('trigger-from-popup');
        $( "#f" ).click();
        popup.closeAllPopup();
	};

    var activeManFilter = function(){
        $( "#m" ).addClass('trigger-from-popup');
        $( "#m" ).click();
        popup.closeAllPopup();
	};
	
	var init = function () {
		playerTools = Fw.component.models().player;
		popup = Fw.component.models().popup;
		formValidator = Fw.component.models().form;
		session = Fw.component.models().session;
		utils = Fw.component.models().utils;

		$('body').on('click', '.change-order-btn', changeOrder);
		$('body').on('click', '.change-sort-order-btn', changeSortOrder);
		$('body').on('click', '.change-studio-filter', changeStudioFilter);
		$('body').on('click', '.change-sourceConnect-filter', changeSourceConnectFilter);
		$('body').on('click', '.change-media-btn', changeMedia);
		$('body').on('click', '.voice-filter-cat-btn', toggleSubcatsCtn);
		$('body').on('click', '.close-filter-cats-btn', closeSubcatsCtn);
		$('body').on('click', '.voice-filter-subcat-btn', toggleSubcatSearch);
		$('body').on('keyup', '.find-a-voice-filter-q-input', enterApplyFilters);
		$('body').on('click', '.voice-filter-btn.reload', applyFilters);
		$('body').on('click', '.voice-filter-btn.clear', clearFilters);
		$('body').on('click', '.demos-only-btn', toggleDemosOnly);
		$('body').on('click', '.change-default-region-btn', changeDefaultRegion);
        $('body').on('click', '.close-region-popup-btn', changeDefaultRegion);
        $('body').on('click', '.hijack-my-artist', hijackAccount);
        $('body').on('click', '.women-filter-btn', activeWomenFilter);
        $('body').on('click', '.man-filter-btn', activeManFilter);

        applyFilters();
	};
	
	$(window).ready(init);
	
})(jQuery);
